import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = {
    key: 1,
    class: "progress is-primary"
};
const _hoisted_3 = {
    key: 2,
    class: "image is-unselectable"
};
const _hoisted_4 = ["src"];
import { PublicStore } from "@/lib/store/public";
import { marked } from "marked";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CampBackground',
    setup(__props) {
        const store = PublicStore();
        return (_ctx, _cache) => {
            return (_unref(store).background === 'error')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "notification is-danger",
                    innerHTML: _unref(marked).parse(_unref(store).website_config.msg_no_picture)
                }, null, 8, _hoisted_1))
                : (_unref(store).background === 'loading')
                    ? (_openBlock(), _createElementBlock("progress", _hoisted_2))
                    : (_openBlock(), _createElementBlock("figure", _hoisted_3, [
                        _createElementVNode("img", {
                            src: _unref(store).background.data_url
                        }, null, 8, _hoisted_4),
                        _renderSlot(_ctx.$slots, "default")
                    ]));
        };
    }
});
